import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./SalesOfTheDay.css";

const SalesOfTheDay = () => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [sectionContent, setSectionContent] = useState({});
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchSectionContent = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/admin/section-content/SalesOfTheDay`);
        setSectionContent(response.data);
      } catch (err) {
        console.error("Failed to fetch section content:", err);
      }
    };
    const fetchVegetableProducts = async () => {
      if (sectionContent.category) {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/products/category/${sectionContent.category}`);
          const productList = Array.isArray(response.data) ? response.data : response.data.products || [];
          setProducts(productList.slice(0, 6));
        } catch (error) {
          console.error("Error fetching vegetable products:", error);
          setError("Failed to load Sales of the Day products.");
        }
      }
    };
    fetchSectionContent();
    fetchVegetableProducts();
  }, [API_BASE_URL, sectionContent.category]);

  if (error) return <div className="sales-error">{error}</div>;
  if (products.length === 0 && !sectionContent.heading) return null;

  return (
    <div className="sales-wrapper">
      <div className="sales-top">
        <div className="sales-top-left">
          <img
            src={sectionContent.bannerImage}
            alt="Sales Banner"
            className="sales-banner"
          />
        </div>
        <div className="sales-top-right">
          <h2 className="sales-heading">{sectionContent.heading}</h2>
          <p className="sales-subheading">{sectionContent.subheading}</p>
        </div>
      </div>

      <div className="sales-grid">
        {products.map((product) => (
          <Link to={`/product/${product._id}`} key={product._id} className="sales-card">
            <div className="sales-card-img-box">
              <img src={product.images[0]} alt={product.name} className="sales-card-img" />
              <div className="sales-offer fw-semi-bold text-light">Exclusive Deals</div>
            </div>
            <div className="sales-title">{product.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SalesOfTheDay;